<template>
  <div :class="$style.news">
    <the-news-item
      v-for="(el, index) in data.list"
      :key="index"
      :data="el"
      :last="index === data.list.length - 1"
    />
    <the-news-page
      :total="data.total"
      :page-size="data.page_size"
      :current-page="currentPage"
      @change="onChange"
    />
  </div>
</template>

<script>
import TheNewsItem from './TheNewsItem'
import TheNewsPage from './TheNewsPage'

export default {
  components: { TheNewsItem, TheNewsPage },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  methods: {
    onChange(index) {
      this.currentPage = index
      this.$emit('change', index)

      // 每次切换分页回到页面顶部
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },
}
</script>

<style lang="less" module>
.news {
  padding: @padding-base 0;
}
</style>
